import { render, staticRenderFns } from "./carinfo-details.vue?vue&type=template&id=788e07aa&scoped=true"
import script from "./carinfo-details.vue?vue&type=script&lang=js"
export * from "./carinfo-details.vue?vue&type=script&lang=js"
import style0 from "./carinfo-details.vue?vue&type=style&index=0&id=788e07aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788e07aa",
  null
  
)

export default component.exports